import { Switch as HeadlessSwitch, SwitchProps as HeadlessSwitchProps } from "@headlessui/react";

type SwitchProps = HeadlessSwitchProps & {
  className?: string;
};

export function Switch({ className = "", ...props }: SwitchProps) {
  return (
    <HeadlessSwitch
      {...props}
      className={`group inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition data-[checked]:bg-dobu-orange ${className}`}
    >
      <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
    </HeadlessSwitch>
  );
}
